import { ca } from '@cian/analytics';

import { TPageType } from '../../../../types/page';
import { IRubricsLinksState } from '../../../../types/rubricsLinks';
import { pageTypeToAnalyticsCategory } from '../../../../utils/pageType';

const MOBWEB_BURGER_MORTGAGE_MAIN_EXTRA = {
  trap_type: 'mobweb_burger_mortgage_main',
  bannerName: 'Ипотека',
  trapid: 'Ипотека',
} as const;

function trackMobwebBurgerMortgageMainTrap(action: 'click_sopr' | 'show_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action,
    label: 'mortgage_button',
    page: {
      extra: MOBWEB_BURGER_MORTGAGE_MAIN_EXTRA,
    },
  });
}

function closureTrackMobwebBurgerMortgageMainShow() {
  let wasEventSent = false;

  return () => {
    if (wasEventSent) {
      return;
    }

    wasEventSent = true;
    trackMobwebBurgerMortgageMainTrap('show_sopr');
  };
}

/** Показ пункта «Ипотека» в рубриках бургер-меню; не более одного события за жизненный цикл страницы */
export const trackMobwebBurgerMortgageMainShow = closureTrackMobwebBurgerMortgageMainShow();

export function trackMobwebBurgerMortgageMainClick() {
  trackMobwebBurgerMortgageMainTrap('click_sopr');
}

function isMobwebBurgerMortgageMainRubric(
  rubricKey: keyof IRubricsLinksState | 'investors',
): rubricKey is 'mortgage' | 'mortgageBrokerPromo' {
  return rubricKey === 'mortgage' || rubricKey === 'mortgageBrokerPromo';
}

export function trackRubricClick(pageType: TPageType, rubricKey: keyof IRubricsLinksState | 'investors') {
  if (isMobwebBurgerMortgageMainRubric(rubricKey)) {
    trackMobwebBurgerMortgageMainClick();

    return;
  }

  const label = mapRubricKeyTolabel(rubricKey);
  if (!label) {
    return;
  }

  ca('eventSite', {
    name: 'oldevent',
    category: pageTypeToAnalyticsCategory(pageType),
    action: 'top_menu',
    label,
  });
}

export function trackSpecialPromoClick(pageType: TPageType, promoKey: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: pageTypeToAnalyticsCategory(pageType),
    action: 'top_menu',
    label: promoKey,
  });
}

function mapRubricKeyTolabel(rubricKey: keyof IRubricsLinksState | 'investors'): string | null {
  switch (rubricKey) {
    case 'commercial':
      return 'commercial';
    case 'mortgage':
      return 'mortgage';
    case 'rent':
      return 'rent';
    case 'rentDaily':
      return 'daily';
    case 'residentialComplexes':
      return 'newobjects';
    case 'sale':
      return 'sale';
    case 'villages':
      return 'KP_new';
    case 'legalCheck':
      return 'legal_check';
    case 'promotions':
      return 'stock';
    case 'realtorSelection':
      return 'demand';
    case 'countryside':
      return 'suburban_landing';
    case 'investors':
      return 'investors';
    case 'layoutsCatalog':
      return 'nb_layout_listing';
  }

  return null;
}
